<template>
    <nav style="width: 100%;">
        <AlertMessages
            v-if="alertValue"
            :alert-type="alertType"
            :alert-msg="alertMsg"
            @reset="alertValue = false"
        />
        <v-btn
            data-testid="continue-with-google-button"
            block
            large
            class="rounded-xxl text-none greytext--text"
            @click="continueWithGoogle()"
            ><v-icon class="mr-2" color="greytext">mdi-google</v-icon>
            {{ $t('continueWithGoogleButton') }}
        </v-btn>
    </nav>
</template>
<script>
import i18n from '../plugins/i18n'
import { getLoginURLForGoogle } from '../api/userApi'
import AlertMessages  from './AlertMessages'

export default {
    components: {
        AlertMessages
    },
    data(){
        return{
            alertType: '',
            alertMsg: '',
            alertValue: false,
        }
    },
    
    created() {
    },
    
    methods: {     
        async continueWithGoogle(){
            const space = window.location.host.split('.')[0];

            var google_referer = {}

            google_referer['space'] = space
            google_referer['page'] = this.$route.name

            if (this.$route.query.referer) {
                if(space == 'id'){
                    google_referer['redirect'] = process.env.VUE_APP_PROTOCOL + "://" + this.$route.query.referer
                }else {
                    google_referer['redirect'] = process.env.VUE_APP_PROTOCOL + "://" + space + "." + process.env.VUE_APP_DOMAIN + this.$route.query.referer
                }
            }/*else if (this.$route.query.redirect) {
                google_referer['redirect'] = process.env.VUE_APP_PROTOCOL + "://" + space + "." + process.env.VUE_APP_DOMAIN + this.$route.query.redirect
            }*/else {   
                google_referer['redirect'] = process.env.VUE_APP_PROTOCOL + "://" + space + "." + process.env.VUE_APP_DOMAIN
            }  

            window.$cookies.set("google_referer", google_referer, 0, null, process.env.VUE_APP_DOMAIN);
            
            try {
                const response = await getLoginURLForGoogle()
                if(response.status == 200) {
                    window.location.href = response.data.meta.detail
                }
            } catch (e){
                if(e.response){
                    this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                }
            }
        }
    }
}
</script>